import { ListIcon } from "lucide-react";
import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Sheet, SheetContent, SheetHeader, SheetTitle, SheetTrigger } from "@/components/ui/sheet";
import { WatchlistSidebar } from "./WatchlistSidebar";

const WatchlistDrawer = () => {
  const location = useLocation();
  const [open, setOpen] = useState(false);

  // Close drawer when route changes
  useEffect(() => {
    setOpen(false);
  }, [location.pathname]);

  return (
    <Sheet open={open} onOpenChange={setOpen}>
      <SheetTrigger asChild>
        <Button variant="ghost" size="icon">
          <ListIcon className="size-5 text-foreground" />
        </Button>
      </SheetTrigger>
      <SheetContent side="right" className="w-80 max-w-full bg-background p-0">
        <SheetHeader className="px-4 py-3 border-b">
          <SheetTitle className="text-lg font-semibold">Watchlists</SheetTitle>
        </SheetHeader>
        <div className="h-full overflow-y-auto">
          <WatchlistSidebar className="border-none bg-transparent" inDrawer={true} />
        </div>
      </SheetContent>
    </Sheet>
  );
};

export default WatchlistDrawer;
export { WatchlistDrawer };
